import { render } from "./Userform.vue?vue&type=template&id=1e7bf2f6"
import script from "./Userform.vue?vue&type=script&lang=js"
export * from "./Userform.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__